import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

document.addEventListener('DOMContentLoaded',function() {
    
    window.runScroll = function(el, o) {
        
        let offsetTop = document.querySelector(el).offsetTop;
        let topbar_height = document.getElementsByClassName('js-topbar')[0].clientHeight;

        o === undefined ? o = 0 : false;

        if (document.querySelector(el).classList.contains('js-child')) {
            document.querySelector(el).scrollIntoView({behavior: "smooth" , inline: "nearest"});
        } else {
            scroll({
                top: offsetTop-topbar_height - o,
                behavior: "smooth"
            })
            
            history.pushState({}, '', el);
        }

        setTimeout(() => {
            if (document.querySelector(el).offsetTop != offsetTop) {
                offsetTop = document.querySelector(el).offsetTop;
                scroll({
                    top: offsetTop-topbar_height - o,
                    behavior: "smooth"
                })
            }
        }, 700);
    };

    const gtt = document.querySelectorAll("[data-target]");
    const privacyindex = document.getElementsByClassName('js-privacyindex')[0];

    if (gtt.length > 0) {
        const action = function(e) {
        	e.preventDefault() ? e.preventDefault() : e.preventDefault = false;  
            let target = e.currentTarget.dataset.target,
                offset = e.currentTarget.dataset.offset;            

            //let url = location.protocol + "//" + document.domain + "/" + location.pathname.split('/')[1];
            let url = '/';
          
            let window_open = '_self';
            
            if (document.getElementsByClassName('page-frontline')) {
                window_open = '_blank';
            }
            
            if (document.documentElement.classList.contains('mobile-menu')) {
                window.hideMenu();
            }
            
            document.querySelector(target) ? window.runScroll(target, offset) :
                window.open(url + target, window_open);
                
/*
            document.getElementById(target.slice(1, target.length)) ? window.runScroll(target, offset) :
                window.open(url + target, '_self');
*/

            if (privacyindex) {
                let i =0,
                    active = privacyindex.getElementsByClassName('is-active')[0];

                active ? active.classList.remove('is-active') : false;
                e.currentTarget.classList.add('is-active');    
            }
        };

        for (let i = 0; i < gtt.length; i++) {
            gtt[i].addEventListener('click', action);
        }
    }
    
}, false);
